<template>
  <v-card class="py-3 pr-3 pl-2" outlined>
    <v-row no-gutters>
      <v-col cols="1" class="pl-1">
        <v-icon>mdi-tag</v-icon>
      </v-col>
      <v-col cols="9" align-self="center">
        <p class="mb-0 pl-3 titulos">Tags</p>
      </v-col>
      <v-col cols="2" class="text-end">
        <c-duvidas
          titulo="Tags"
          texto="Selecione as tags que deseja que sua assinatura de e-mail possua, para que eles sejam inseridos no campo 'Modelo de Assinatura'."
        ></c-duvidas>
      </v-col>
    </v-row>

    <div v-for="campo in tagsDaAssinatura"  :key="campo.id">
      <v-checkbox 
        v-model="campo.value" 
        class="mt-1" 
        hide-details 
        @change="enviarTagParaAssinatura(campo)"
        :disabled="desabilitarTags()">
        <template v-slot:label>
          <label>{{ campo.texto }}</label>
        </template>
      </v-checkbox>
     </div>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Duvidas from "../Duvidas";

export default {
  name: "simple",
  display: "Simple",
  order: 0,
  computed: {
    ...mapState(["tagsDaAssinatura", "aplicarAssinatura", "editorAssinaturaEstaAtivo"])
  },
  methods: {
    ...mapActions(["atualizarTag"]),

    enviarTagParaAssinatura(campo){
      const acao = {
        nome: campo.nome,
        valor: true,
        texto: campo.texto
      }
      if (campo.value) {
        return this.atualizarTag(acao);
      }
      acao.valor = false;
      return this.atualizarTag(acao);
    },
    desabilitarTags() {
      if (this.aplicarAssinatura.id == null) {
        return true;
      }
      return this.editorAssinaturaEstaAtivo;
    },
  },
  components: {
    "c-duvidas": Duvidas
  }
};
</script>


